import { instance } from "../api/axiosInstance";
const axios = instance;

export async function createCityAdmin(params) {
    return axios.post(`/admin/register`, params);
}

export async function fetchCreatedAdmins() {
    return axios.get('/admin/userlistings');
}

export async function fetchAdminTerminalsRequests() {
    return axios.get('/terminals');
}

export async function fetchAdminCategoryRequests() {
    return axios.get('/categories');
}

export async function fetchAdminTerminalsServicesRequests() {
    return axios.get('/terminalsServices');
}

export async function updateCategoryStatus(id, params) {
    return axios.put(`/categories/${id}/status`, params);
}

export async function updateTerminalsServicesStatus(id, params) {
    return axios.put(`/terminalsServices/${id}/status`, params);
}

export async function fetchAdminTerminalsAdsRequests() {
    return axios.get('/terminalsAds');
}

export async function fetchAdminTerminalsQRCodesRequests() {
    return axios.get('/qrcodes');
}

export async function updateTerminalsStatus(id, params) {
    return axios.put(`terminals/${id}/status`, params);
}

export async function updateTerminalsAdsStatus(id, params) {
    return axios.put(`terminalsAds/${id}/status`, params);
}

export async function updateTerminalsQRCodesStatus(id, params) {
    return axios.put(`qrcodes/${id}/status`, params);
}

export async function fetchTerminalById(id) {
    return axios.get(`/terminals/${id}/admin`);
}

export async function fetchTerminalServiceById(id) {
    return axios.get(`/terminalsServices/${id}/admin`);
}

export async function fetchTerminalAdById(id) {
    return axios.get(`/terminalsAds/${id}/admin`);
}

export async function fetchQRCodeById(id) {
    return axios.get(`/qrcodes/${id}/admin`);
}

export async function fetchCategoryById(id) {
    return axios.get(`/categories/${id}/admin`);
}

export async function getCityAdminTerminalRequests(id) {
    return axios.get(`/terminals/${id}`);
}